module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Diófa Apartmanok","short_name":"diofa.hu","start_url":"/","background_color":"#fff","theme_color":"#4E822B","display":"minimal-ui","icon":"src/data/images/logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"122fcd20cf7e8645ebdc29d90f8f1085"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
